import { useState } from 'react';
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from '../../../../../../../context/AuthContext';

const AnswerForm = (props) => {
    const { t } = useTranslation()
    const [msg, setMsg] = useState([]);
    const { user } = useAuth();

    const handleServiceRemove = (index) => {
        const list = [...props.serviceList];
        list.splice(index, 1);
        props.setServiceList(list);
    };
    const handleServiceAdd = () => {
        props.setServiceList([...props.serviceList, { service: "" }]);
    };
    const handleServiceChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...props.serviceList];
        list[index][name] = value;
        props.setServiceList(list);
    };


    const handleAnswerPhoto = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const { name, value } = e.target;
            const list = [...props.serviceList];
            list[index]["photo"] = url;
            props.setServiceList(list);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "photo"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const { name, value } = e.target;
                    const list = [...props.serviceList];
                    list[index][name] = url;;
                    props.setServiceList(list);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }

    };
    const deleteMedia = async (e, type) => {
        e.preventDefault();
        if (type === "photo") {
            const list = [...props.serviceList];
            list[e.target.id]["photo"] = "";
            props.setServiceList(list);
        }
        else if (type === "video") {
            const list = [...props.serviceList];
            list[e.target.id]["video"] = "";
            props.setServiceList(list);
        }
        else {
            const list = [...props.serviceList];
            list[e.target.id]["sound"] = "";
            props.setServiceList(list);
        }
    }
    const handleAnswerVideo = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const list = [...props.serviceList];
            list[index]["video"] = url;
            props.setServiceList(list);
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "video"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const { name, value } = e.target;
                    const list = [...props.serviceList];
                    list[index][name] = url;;
                    props.setServiceList(list);
                });
            } catch (err) {
                setMsg(err.message);
            }
        }

    };
    const handleAnswerSound = async (e, index) => {
        if (e.target.type === "textarea") {
            let url = e.target.value;
            const { name, value } = e.target;

            const list = [...props.serviceList];
            list[index]["sound"] = url;
            props.setServiceList(list);
            console.log(props.serviceList)
        }
        else if (e.target.type === "file") {
            const formData = new FormData();
            formData.append('FormFile', e.target.files[0]);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                const url = 'https://api.heryerdeingilizce.com/api/admin/ContentFile/UploadFile';
                await axios({
                    method: 'Post',
                    url: url,
                    params: {
                        mediaType: "sound"
                    },
                    data: formData,
                    headers: headerss
                }).then(res => {
                    let url = "https://api.heryerdeingilizce.com/" + res.data['data']['path']
                    alert("Yüklendi")
                    const { name, value } = e.target;
                    const list = [...props.serviceList];
                    list[index][name] = url;;
                    props.setServiceList(list);
                    console.log(props.serviceList)

                });
            } catch (err) {
                setMsg(err.message);
            }
        }

    };


    return (
        <form className="App" autoComplete="off">
            {msg}
            <hr />
            <div className="form-field">
                <div style={{ textAlign: "center" }}><h2>{t('answers')}</h2></div>

                {props.serviceList.map((singleService, index) => (
                    <div key={index} className="services">
                        <div className="first-division" style={{ padding: "1%", border: "3px solid black" }}>
                            <span>Medya dosyası ekledikten sonra, hatalı yükleme durumunda tekrardan dosya yükle butonuna basıp yeni dosyayı yükleyebilirsiniz!</span>
                            <div className=" d-flex justify-content-center" style={{ alignItems: "center" }}>
                                <h5>cevap {index + 1}</h5>

                            </div>
                            {props.file === true &&
                                <div className="row" style={{ padding: "1%" }}>
                                    <div className="col-md-4">
                                        <div class="mb-1">
                                            <label for="photo" class="form-label">{t("addPhoto")}</label> <i>1:1 oranında 566*566 pixel ve üzeri </i>
                                            <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={(e) => handleAnswerPhoto(e, index)} id="photo" name="photo" required />
                                        </div>
                                        <div class="mb-1">
                                            <label for="photoUrl" class="form-label">{t("addPhotobyUrl")}</label>
                                            <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAnswerPhoto(e, index)} id="photoUrl" name="photoUrl" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div class="mb-1">
                                            <label for="video" class="form-label">{t("addVideo")}</label> <i>1:1 oranında </i>
                                            <input class="form-control" type="file" accept='video' onChange={(e) => handleAnswerVideo(e, index)} id="video" name="video" required />
                                        </div>
                                        <div class="mb-1">
                                            <label for="videoUrl" class="form-label">{t("addVideobyUrl")}</label>
                                            <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAnswerVideo(e, index)} id="videoUrl" name="videoUrl" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div class="mb-1">
                                            <label for="sound" class="form-label">{t("addSound")}</label>
                                            <input class="form-control" type="file" accept=".mp4,.mp3,audio/*" onChange={(e) => handleAnswerSound(e, index)} id="sound" name="sound" required />
                                        </div>
                                        <div class="mb-1">
                                            <label for="soundUrl" class="form-label">{t("addSoundbyUrl")}</label>
                                            <textarea class="form-control" rows={1} type="text" onChange={(e) => handleAnswerSound(e, index)} id="soundUrl" name="soundUrl" />
                                        </div>
                                    </div>
                                </div>
                            }

                            <div >
                                <h6 for="service" class="form-label">{t("answerText")}</h6><i>boş ise 1 ader boşluk giriniz. (sadece video/resim/ses var ise)</i> <i>{props.infoText}</i>
                                <textarea class="form-control" name="service" id="service" value={singleService.service} onChange={(e) => handleServiceChange(e, index)} required />
                                <br />

                                <div className="second-division d-flex justify-content-center" >
                                    {props.serviceList.length !== 1 && (
                                        <button
                                            type="button"
                                            onClick={() => handleServiceRemove(index)}
                                            className="remove-btn btn btn-warning"
                                        >
                                            <span>{t('remove')}</span>
                                        </button>
                                    )}
                                </div>
                            </div>
                            <br />

                        </div>
                        <br />
                        <div className='d-flex justify-content-center'>
                            {props.serviceList.length - 1 === index && props.serviceList.length < 6 && (
                                <button
                                    type="button"
                                    onClick={handleServiceAdd}
                                    className="add-btn btn btn-info"
                                >
                                    <span>{t('addAnswerOption')}</span>
                                </button>
                            )}</div>
                        {/* <div className="second-division">
                            {props.serviceList.length !== 1 && (
                                <button
                                    type="button"
                                    onClick={() => handleServiceRemove(index)}
                                    className="remove-btn btn btn-warning"
                                >
                                    <span>{t('remove')}</span>
                                </button>
                            )}
                        </div>
                        <br /> */}
                    </div>
                ))}
            </div>
            <hr />
            <div className="output">
                <div style={{ textAlign: "center" }}><h2>{t('answers')}</h2></div>
                {props.serviceList &&
                    props.serviceList.map((singleService, index) => (
                        <ul key={index} style={{ border: "1px solid black", padding: "10px" }}>
                            {singleService.service &&
                                <div>
                                    <li>
                                        {index + 1} = Text:{singleService.service}
                                        <br /> Image Url: {singleService.photo} <button id={index} className='btn btn-danger' onClick={(e) => deleteMedia(e, "photo")}   > resmi iptal et</button><br />
                                        <br /> Video Url: {singleService.video} <button id={index} className='btn btn-danger' onClick={(e) => deleteMedia(e, "video")}  > video iptal et</button><br />
                                        <br /> Sound Url: {singleService.sound} <button id={index} className='btn btn-danger' onClick={(e) => deleteMedia(e, "sound")}  > ses iptal et</button>
                                    </li>
                                </div>
                            }

                        </ul>
                    ))}
            </div>
        </form >
    );
};

export default AnswerForm;